import React from 'react';
import tipsIcon from 'assets_vacanted/icons/tips_icon.png';
import countryService from 'services/countryService';
import vStyles from '../../FamilyInfo.module.scss';

const tips = [
  {
    title: 'Consideraciones',
    content: 'Si usted considera que no se ajusta a la realidad, puede seleccionar atrás y modificar la información detallada en páginas anteriores.',
  },
  {
    title: 'Moneda',
    content: `Recuerde que los montos se expresan en ${countryService.getCurrencySymbolWithDescription()}.`,
  },
];

const PageElevenTips = () => (
  tips.map((tip) => (
    <div className={vStyles.vacantest__tip} key={tip.title}>
      <div className={vStyles.vacantest__tip__icon}>
        <img src={tipsIcon} alt="tips" />
      </div>
      <div className={vStyles.vacantest__tip__title}>
        <p>{tip.title}</p>
      </div>
      <div className={vStyles.vacantest__tip__content}>
        <p>{tip.content}</p>
      </div>
    </div>
  ))
);

export default PageElevenTips;
